export default "__VITE_ASSET__DkuLwiUO__"